import type { ReactNode, RefObject } from 'react';
import { PopupDialog } from '@vigeo/ui';

/**
 * A pop-up for reading the letter or the portal preview without leaving the screen (#440). It is the large size, up to 960 wide
 * and never taller than 90% of the window, with the middle scrolling (#502). Closing it — the X, Esc, a click outside or the
 * Close button — puts HR back exactly where they were, on the same offer screen with nothing reloaded.
 */
export function OfferPreviewDialog({ open, title, onClose, opener, children }: {
  readonly open: boolean;
  readonly title: string;
  readonly onClose: () => void;
  /** The button that opened it, so the keyboard goes back there (Safari on a Mac does not focus a button on click). */
  readonly opener?: RefObject<HTMLElement | null>;
  readonly children: ReactNode;
}) {
  // Nothing to cancel and nothing to submit: a lone blue Close (PG13), where the keyboard starts.
  return (
    <PopupDialog open={open} title={title} size="large" opener={opener} startOn="primary" showX={false} cancelLabel={null} onClose={onClose} primary={{ label: 'Close', onClick: onClose }}>
      {children}
    </PopupDialog>
  );
}
